<template>
  <nav class="nav-menu" :class="tabList.length < 4 ? 'center' : ''">
    <div class="tab-wrapper">
      <div class="tab-list">
        <div
          class="tab-item"
          v-for="(item, index) in tabList"
          :key="`tabItem${index}`"
          :class="activeIndex === index ? 'active' : ''"
          :ref="`tabItem_${index}`"
          @click="handleClickNav(index, item)"
          :style="{ width: item.width }"
        >
          <span>{{ item.name }}</span>
          <i v-if="item.type === 'select'" class="icon icon-arrow" :class="showPicker[`showPicker_${item.value}`] ? 'active' : ''"></i>
        </div>
      </div>
    </div>
    <component
      :is="renderAreaPickerCmp()"
      v-model="showPicker[`showPicker_AREA`]"
      @cancel="handleCloseMask"
      @confirm="handleSelArea"
      :dataList="areaPickerRegionData"
    />
    <component
      :is="renderActivityPicker()"
      v-model="showPicker[`showPicker_ACTIVITY_CATEGORY`]"
      :activityType="activityCategorys"
      @chooseActivity="handleSelActivity"
    />
    <component
      :is="renderWorksTypePicker()"
      v-model="showPicker[`showPicker_WORKSTYPE`]"
      :activityType="worksTypes"
      @chooseActivity="handleSelWorksType"
    />
    <!-- <component :is="renderAreaPickerCmp"/> -->
  </nav>
</template>

<script>
import AreaPicker from "@/components/AreaPicker"
import ActivityPicker from "@/components/ActivityPicker"
import { WORKS_TAB_MAP } from "@/dictionary"
import { mapGetters } from "vuex"

export default {
  name: "navMenu",
  data() {
    return {
      activeIndex: 0,
      activeBarTranslate: 0,
      showPicker: {},
      currentShowPickerKey: "",
      tabList: []
    }
  },
  methods: {
    toggleMenu(index) {
      if (!this.tabList.length) return
      this.activeIndex = index
      // this.$nextTick(() => {
      //   const activeItem = this.$refs[`tabItem_${index}`][0]
      //   const activeBar = this.$refs.activeBar
      //   this.activeBarTranslate = activeItem.offsetLeft + activeItem.offsetWidth / 2 - activeBar.offsetWidth / 2
      // })
    },
    closePicker() {
      this.currentShowPickerKey && (this.showPicker[this.currentShowPickerKey] = false)
    },
    handleClickNav(index, item) {
      this.toggleMenu(index)
      const currentNavItem = this.tabList[index]
      if (currentNavItem.type === "select") {
        const key = `showPicker_${currentNavItem.value}`
        this.showPicker[key] = !this.showPicker[key]
        if (this.showPicker[key]) {
          this.currentShowPickerKey = key
          this.$emit("showMask")
        }
      }
      this.$emit("toggleMenu", item.value, item.id, item, index)
    },
    handleCloseMask() {
      this.$emit("closeMask")
    },
    initData() {
      this.tabList.forEach(item => {
        if (item.type === "select" && item.value) {
          this.$set(this.showPicker, `showPicker_${item.value}`, false)
        }
      })
      this.toggleMenu(0)
    },
    renderAreaPickerCmp() {
      return this.indexNavigations.indexOf("AREA") > -1 ? AreaPicker : null
    },
    renderActivityPicker() {
      return (this.activityCategorys && this.activityCategorys.length > 0 && this.indexNavigations.indexOf("ACTIVITY_CATEGORY")) > -1
        ? ActivityPicker
        : null
    },
    renderWorksTypePicker() {
      return (this.worksTypes && this.worksTypes.length > 0 && this.indexNavigations.indexOf("WORKSTYPE")) > -1 ? ActivityPicker : null
    },
    handleSelArea(selInfo) {
      const { selItem } = selInfo
      const regionItem = selItem.reverse().find(item => !item.isAll)
      const region = regionItem ? regionItem.name : "投稿地区"
      const keyword = regionItem ? regionItem.keyword : ""
      const tabIndex = this.tabList.findIndex(item => item.value === "AREA")
      if (tabIndex > -1) {
        this.tabList[tabIndex].name = region
        this.$emit("selArea", keyword)
      }
    },
    handleSelActivity(selItem) {
      const tabIndex = this.tabList.findIndex(item => item.value === "ACTIVITY_CATEGORY")
      if (tabIndex > -1) {
        this.tabList[tabIndex].name = selItem.isAll ? "参评项目" : selItem.name
        this.$emit("selActivity", selItem)
      }
    },
    handleSelWorksType(selItem) {
      const tabIndex = this.tabList.findIndex(item => item.value === "WORKSTYPE")
      if (tabIndex > -1) {
        this.tabList[tabIndex].name = selItem.isAll ? "作品类型" : selItem.typeName
        this.$emit("selWorksType", selItem.typeId)
      }
    },
    init() {
      this.initData()
    }
  },
  computed: {
    ...mapGetters({
      indexNavigations: "activityInfo/indexNavigations",
      regionData: "activityInfo/regionData",
      areaPickerRegionData: "activityInfo/areaPickerRegionData",
      activityCategorys: "activityInfo/activityCategorys",
      worksTypes: "activityInfo/worksTypes"
    }),
    isClosePicker() {
      let ret = true
      Object.keys(this.showPicker).forEach(key => {
        if (this.showPicker[key]) {
          ret = false
        }
      })
      return ret
    }
  },
  watch: {
    indexNavigations(newValue) {
      if (Array.isArray(newValue)) {
        this.tabList = []
        newValue.forEach(item => {
          if (item === "ACTIVITY_CATEGORY") {
            if (this.activityCategorys && this.activityCategorys.length > 1) {
              // const defaultActivity = this.activityCategorys.find(item => item.isDefault)
              // let name = WORKS_TAB_MAP[item].name
              // if (defaultActivity) {
              //   name = defaultActivity.name
              // }
              // this.tabList.push({
              //   name: name,
              //   value: item,
              //   type: WORKS_TAB_MAP[item].type || "",
              //   width: WORKS_TAB_MAP[item].width
              // })
              this.activityCategorys.forEach(childItem => {
                if (!childItem.isAll) {
                  this.tabList.push({
                    name: childItem.name,
                    value: item,
                    type: WORKS_TAB_MAP[item].type || "",
                    width: WORKS_TAB_MAP[item].width,
                    id: childItem.id,
                    activityDesc: childItem.activityDesc,
                    activityPicUrl: childItem.activityPicUrl
                  })
                }
              })
            }
          } else if (item === "WORKSTYPE") {
            if (this.worksTypes && this.worksTypes.length > 1) {
              this.tabList.push({
                name: WORKS_TAB_MAP[item].name,
                value: item,
                type: WORKS_TAB_MAP[item].type || "",
                width: WORKS_TAB_MAP[item].width
              })
            }
          } else {
            this.tabList.push({
              name: WORKS_TAB_MAP[item].name,
              value: item,
              type: WORKS_TAB_MAP[item].type || "",
              width: WORKS_TAB_MAP[item].width
            })
          }
        })
      }
    },
    tabList(newValue) {
      if (Array.isArray(newValue)) {
        this.initData()
      }
    },
    isClosePicker(newValue) {
      if (newValue) {
        this.$emit("closeMask")
      }
    }
  },
  mounted() {
    this.toggleMenu(0)
  },
  created() {
    this.init()
  }
}
</script>

<style lang="scss" scoped>
.nav-menu {
  display: flex;
  align-items: center;
  justify-content: space-between;
  font-family: PingFangSC-Regular;
  font-size: 0.28rem;
  color: #666666;
  line-height: 0.4rem;
  position: relative;
  cursor: pointer;
  height: 0.52rem;
  background: #ffffff;
  margin-top: -1px;
  .tab-wrapper {
    display: flex;
    align-items: center;
    justify-content: space-between;
    flex-wrap: nowrap;
    overflow: auto;
    min-width: 100%;
    height: 100%;
    position: relative;
    &::-webkit-scrollbar {
      display: none;
    }
    .tab-list {
      display: flex;
      align-items: center;
      justify-content: center;
      flex-wrap: nowrap;
      overflow: visible;
      padding: 0 0.3rem;
      height: 100%;
      position: relative;
      flex: 1;
      &:after {
        content: "";
        display: block;
        position: absolute;
        bottom: 0;
        left: 0;
        right: 0;
        border-bottom: 1px solid #eeeeee;
      }
    }
  }
  &.center {
    justify-content: center;
  }
  .tab-item {
    flex: none;
    // margin-right: 0.35rem;
    transition: all 0.3s;
    position: relative;
    display: flex;
    align-items: center;
    justify-content: center;
    z-index: 10;
    line-height: 0.4rem;
    overflow: hidden;
    margin-right: 0.48rem;
    position: relative;
    height: 100%;
    &:after {
      content: "";
      position: absolute;
      left: 50%;
      bottom: 0;
      transform-origin: 50% 50%;
      transform: translate3d(-50%, 0, 0) scaleX(0);
      z-index: 1;
      display: inline-block;
      height: 0.04rem;
      width: 0.4rem;
      background: #f64e45;
      border-radius: 0.03rem;
      opacity: 0;
      transition: all 0.3s ease-in-out;
    }
    &:last-child {
      margin-right: 0;
    }
    &.active {
      color: #f64e45;
      &:after {
        content: "";
        position: absolute;
        left: 50%;
        bottom: 0;
        transform: translate3d(-50%, 0, 0) scaleX(1);
        z-index: 1;
        display: inline-block;
        height: 0.04rem;
        width: 0.4rem;
        background: #f64e45;
        border-radius: 0.03rem;
        opacity: 1;
        transition: all 0.3s ease-in-out;
      }
    }
    &:hover {
      color: #f64e45;
    }
    > span {
      // max-width: 1.13rem;
      text-align: center;
      flex: 1;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
    }
    .icon-arrow {
      flex: none;
      display: inline-block;
      border-color: transparent;
      border-top: 0.1rem solid #dddddd;
      border-left: 0.085rem solid transparent;
      border-right: 0.085rem solid transparent;
      border-bottom: 0.1rem solid transparent;
      transform: translate3d(0, 0.05rem, 0);
      transform-origin: 50% 0.05rem;
      transition: all 0.3s ease-in-out;
      &.active {
        transform: translate3d(0, 0.05rem, 0) rotate(180deg);
      }
    }
  }
  .active-bar {
    position: absolute;
    bottom: 0;
    left: 0;
    z-index: 1;
    display: inline-block;
    height: 0.04rem;
    width: 0.4rem;
    background: #f64e45;
    border-radius: 0.03rem;
    transition: all 0.3s ease-in-out;
  }
}
</style>
